export default __webpack_public_path__ + "static/media/13.77ec294d.jpg";